import FJActionConstant from '../constant/FJActionConstant';
import FJNetworkStore from '../store/FJNetworkStore';
import FJCaptcha from '../store/FJCaptcha';
import FJLocalStore from '../store/FJLocalStore';
import FJMessageStore from '../store/FJMessageStore';
import FJUtil from '../util/FJUtil';
import FJViewConstant from '../constant/FJViewConstant';

export default {
    // 打开登录注册面板
    openLoginView: function (obj) {
        return (dispatch, getState) => {
            let email = getState().mainStore.email;
            dispatch({
                type: FJActionConstant.SHOW_LOGIN_VIEW,
                method: obj?.method ?? 'popup',
                page: obj.page,
                email: obj?.email ? obj.email : email,
            });
        };
    },
    // 关闭登录注册面板
    closeLoginView: function () {
        return (dispatch, getState) => {
            let step = getState().mainStore.step;
            dispatch({ type: FJActionConstant.CLOSE_LOGIN_VIEW });
            if (step === 'resetPassword') {
                dispatch(this.changeStep('default'));
            }
        };
    },

    // 改变倒计时剩余时间
    setIntervalTime: value => {
        return {
            type: FJActionConstant.SET_INTERVAL_TIME,
            value,
        };
    },

    // 改变倒计时剩余时间
    changeVerificationTimeShow: value => {
        return {
            type: FJActionConstant.VERIFICATION_TIME_SHOW,
            value,
        };
    },

    setCountdownAndSendCode: value => {
        return {
            type: FJActionConstant.SET_COUNT_DOWN_AND_SEND_CODE,
            value,
        };
    },

    // 改变忘记密码倒计时剩余时间
    setForgetPasswordIntervalTime: value => {
        return {
            type: FJActionConstant.SET_FORGET_PASSWORD_INTERVAL_TIME,
            value,
        };
    },

    // 改变忘记密码倒计时剩余时间
    changeForgetPasswordTimeShow: value => {
        return {
            type: FJActionConstant.FORGET_PASSWORD_TIME_SHOW,
            value,
        };
    },

    // 改变倒计时剩余时间
    changeRegisterCode: registerCode => {
        return {
            type: FJActionConstant.CHANGE_REGISTER_CODE,
            registerCode,
        };
    },

    // 改变步骤
    changeStep: step => {
        return {
            type: FJActionConstant.CHANGE_STEP,
            step: step,
        };
    },

    // 注册密码改变
    changeRegisterPasswordAction: password => {
        return {
            type: FJActionConstant.CHANGE_REGISTER_PASSWORD,
            password: password,
        };
    },

    // 邮箱改变
    changeEmail: email => {
        return {
            type: FJActionConstant.CHANGE_EMAIL,
            email: email,
        };
    },
    // 改变 发送验证的邮箱
    changeConfirmEmail: email => {
        return {
            type: FJActionConstant.CHANGE_CONFIRM_EMAIL,
            confirmEmail: email,
        };
    },

    forgetPasswordAction: function (obj) {
        return async (dispatch, getState) => {
            dispatch(this.changeConfirmEmail(obj.email));
            dispatch(this.changeStep('confirmationEmail'));
        };
    },

    // 验证码发送前进行谷歌人机验证
    recaptchaVerify: function (obj, callback, type) {
        FJCaptcha.beginRecaptcha((option) => {
            const { recaptcha, rt } = option
            const data = {
                email: obj.email,
                type: obj.type,
                is_resend: obj.is_resend,
                code_language: obj.code_language,
                recaptcha,
                rt,
                rand_str: ''
            }
            FJNetworkStore.sendEmail(data).then(res => {
                switch (res.code) {
                    case 200:
                        callback({ result: true, errTip: null })
                        break;
                    case 403:
                        FJMessageStore.addMessage(FJLocalStore._('recaptcha-verify-failed'), 'warning');
                        callback({ result: false, errTip: FJLocalStore._('recaptcha-verify-failed') })
                        break;
                    case 500:
                        FJMessageStore.addMessage(FJLocalStore._('failed-send-code'), 'warning');
                        callback({ result: false, errTip: FJLocalStore._('failed-send-code') })
                        break;
                    default:
                        FJMessageStore.addMessage(FJLocalStore._('failed-send-code'), 'warning');
                        callback({ result: false, errTip: null })
                        break;
                }
            })
                .catch(() => {
                    if (callback) {
                        callback({ result: false, networkFail: true, errTip: FJLocalStore._('network-error') });
                    }
                });
        }, () => { }, type)
    },

    // 检查邮件账号是否存在
    checkEmail: function (obj, callback) {
        return (dispatch, getState) => {
            // 用户注册时，倒计时标志
            const verificationTimeShow = getState().mainStore.verificationTimeShow;

            // 用来控制倒计时后，重新发送验证码的标志
            const setCountdownAndSendCode = getState().mainStore.setCountdownAndSendCode;

            const startCountDown = () => {
                dispatch(this.changeVerificationTimeShow(true));
                dispatch(this.setIntervalTime(60));
                FJUtil.countDown(
                    'verification',
                    59,
                    value => {
                        if (Boolean(value)) {
                            dispatch(this.setIntervalTime(value));
                        } else {
                            dispatch(this.setIntervalTime(null));
                            dispatch(this.changeVerificationTimeShow(false));
                            dispatch(this.setCountdownAndSendCode(false));
                        }
                    },
                    false,
                )();
            };

            if (verificationTimeShow) {
                dispatch(this.changeStep('verifyEmailCode'));
                dispatch(this.changeConfirmEmail(obj.email));
                return;
            }

            if (setCountdownAndSendCode) {
                let resendSuccessFun = resendResult => {
                    if (resendResult.code === 200) {
                        dispatch(this.changeVerificationTimeShow(true));
                        dispatch(this.changeStep('verifyEmailCode'));
                        dispatch(this.changeConfirmEmail(obj.email));
                        startCountDown();
                    }
                };
                const resendObj = {
                    email: obj.email,
                    type: 1,
                    is_resend: 1,
                    code_language: FJLocalStore.currentTag(),
                };
                dispatch(this.resendCode(resendObj, resendSuccessFun));
                return;
            }
            FJNetworkStore.checkAccountExist(obj)
                .then(result => {
                    // 状态码，200注册 201登录 215参数错误 500发送验证码失败
                    let code = result.code;
                    callback({ result: true });
                    if (code === 200) {
                        const isMobile = FJUtil.isMobile();
                        const recaptchaBox = document.getElementById('verify-recaptcha');
                        if (isMobile) {
                            recaptchaBox.style.paddingBottom = '100px';
                        }
                        this.recaptchaVerify(obj, ({ result }) => {
                            if (result) {
                                startCountDown();
                                dispatch(this.changeStep('verifyEmailCode'));
                                dispatch(this.changeConfirmEmail(obj.email));
                                FJMessageStore.addMessage(FJLocalStore._('success-send-code'), 'message');
                            }
                        }, 'verify')
                    } else if (code === 201) {
                        dispatch(this.changeStep('login'));
                    } else if (code === 215) {
                        callback({ result: false, errTip: FJLocalStore._('enter-valid-email') });
                    } else if (code === 305) {
                        callback({ result: false, errTip: FJLocalStore._('enter-valid-email') });
                    } else if (code === 500) {
                        callback({ result: false, errTip: FJLocalStore._('network-error') });
                    } else if (code === 306) {
                        dispatch(this.changeStep(FJViewConstant.RESTORE_ACCOUNT));
                        FJUtil.setLoginInfo({});
                        dispatch(this.setRestoreExpireTimeAction(result.data.expiration_days));
                    }
                    // callback({result: true})
                })
                .catch(() => {
                    callback({ networkFail: true, errTip: FJLocalStore._('network-error') });
                });
        };
    },

    changeCountryCode: function (countryCode) {
        return {
            type: FJActionConstant.CHANGE_COUNTRY_CODE,
            countryCode: countryCode,
        };
    },

    loadCaptchaApi: function (callback) {
        return async (dispatch, getState) => {
            const url = 'https://www.google.com/recaptcha/api.js?render=explicit';
            try {
                await FJCaptcha.loadApi(url);
                callback && callback();
            } catch (e) {
                throw new Error(e);
            }
        };
    },

    // 邮箱注册
    emailRegister: function (data, callback) {
        return async (dispatch, getState) => {
            let method = getState().mainStore.method;
            let page = getState().mainStore.page;
            const email = getState().mainStore.email;
            let origin = method === 'single' ? page : window.location.pathname;

            const __doStatistics = reason => {
                FJUtil.ealog('sign up error', {
                    'error reason': reason,
                    'error mode': 'email',
                    'error page': 'page_' + origin,
                    'error account': email,
                });
            };

            let _register = data => {
                FJNetworkStore.emailRegister({ ...data })
                    .then(res => {
                        if (res.code === 200) {
                            FJUtil.ealog('sign up', {
                                signUpMode: 'email',
                                'page&panel': method === 'single' ? 'page' : 'panel',
                                signUpPage: 'page_' + origin,
                                signUpAccount: 'Account_' + data.email,
                            });
                            dispatch(this.changeRegisterPasswordAction('')); // 注冊成功删除密码
                            dispatch(this.emailLogin({ email: data.email, password: data.password }, () => { }, false));
                            FJUtil.facebookAdTracking('CompleteRegistration');
                        } else if (res.code === 305) {
                            callback({ result: false, errTip: FJLocalStore._('enter-valid-email') });
                            __doStatistics(res.code);
                        } else if (res.code === 316) {
                            // 验证码错误
                            dispatch(this.changeStep('default'));
                            FJMessageStore.addMessage(FJLocalStore._('invalid-verification-code'), 'error');
                            __doStatistics(res.code);
                        } else if (res.code === 317) {
                            // 验证码过期
                            dispatch(this.changeStep('default'));
                            FJMessageStore.addMessage(FJLocalStore._('flow-overtime'), 'error');
                            __doStatistics(res.code);
                        } else if (res.code === 404) {
                            window.location.href = '/404.html';
                            __doStatistics(res.code);
                        } else if (res.code === 500) {
                            __doStatistics(res.code);
                            window.location.href = '/' + res.data.link;
                        } else {
                            __doStatistics('sign up failed');
                            FJMessageStore.addMessage(FJLocalStore._('sign-up-failed'), 'error');
                            // callback({result: false, errTip: FJLocalStore._('sign-up-failed')})
                        }
                    })
                    .catch(e => {
                        __doStatistics('reg network error');
                        if (callback) {
                            callback({ networkFail: true, errTip: FJLocalStore._('network-error') });
                        }
                    });
            };

            _register(data);
            return;
        };
    },
    // 邮箱登录
    emailLogin: function (data, callback, isLoginByLoginButton = true) {
        return async (dispatch, getState) => {
            let method = getState().mainStore.method;
            const __recaptchaLogin = async loginSource => {
                const __funDone = () => {

                    FJCaptcha.beginRecaptcha(
                        option => {
                            _login(
                                {
                                    email: data.email,
                                    password: data.password,
                                    ...option,
                                },
                                {
                                    captcha_source: loginSource === 305 ? 1 : 0,
                                    captcha: 1,
                                },
                            );
                        },
                        errorMsg => {
                            if (callback) {
                                callback({
                                    result: true,
                                });
                            }
                        },
                        'login',
                    );
                };
                // 正在加载sdk
                if (FJCaptcha.getApiIsApiLoading()) {
                    await FJUtil.polling(() => FJCaptcha.getApiIsApiLoading() === false);
                    __funDone();
                } else {
                    if (!FJCaptcha.getApiIsLoaded()) {
                        try {
                            await dispatch(this.loadCaptchaApi());
                            __funDone();
                        } catch (e) {
                            if (callback) {
                                callback({
                                    result: true,
                                });
                            }
                        }
                    } else {
                        __funDone();
                    }
                }
            };

            let _login = (option, recordOptions = {}) => {
                FJNetworkStore.emailLogin({ ...option })
                    .then(res => {
                        if (res.code === 200) {
                            window.needLoginRecaptcha = false;
                            if (method !== 'single') {
                                dispatch(this.changeStep('default'));
                                dispatch(this.closeLoginView());
                                window.fjuser.dispatchCallbacks(window.fjuser.eventType.login, true, res);
                                // dispatch(this.changeEmail(''))
                            } else {
                                window.location.href = FJUtil.getBaseUrl();
                            }
                            if (FJUtil.isMobile()) {
                                dispatch(this.loadSubscriptionJs());
                            }
                        } else if (res.code === 205) {
                            if (callback) {
                                callback({
                                    result: false,
                                    errTip: FJLocalStore._('password-err'),
                                });
                            }
                            if (res.data.needCaptcha) {
                                window.needLoginRecaptcha = res.data.needCaptcha;
                            }
                        } else if (res.code === 305) {
                            if (res.data.needCaptcha) {
                                __recaptchaLogin(305);
                            }
                        } else if (res.code === 404) {
                            window.location.href = '/404.html';
                        } else if (res.code === 500) {
                            window.location.href = '/' + res.data.link;
                        }
                    })
                    .catch(err => {
                        if (callback) {
                            callback({ networkFail: true, errTip: FJLocalStore._('network-error') });
                        }
                    });
            };
            if (window.needLoginRecaptcha === true) {
                __recaptchaLogin(205);
            } else {
                _login(
                    { email: data.email, password: data.password },
                    {
                        captcha: 0,
                    },
                );
            }
        };
    },

    // 移动端动态加载订阅页js
    loadSubscriptionJs: function () {
        return async () => {
            const url = await FJNetworkStore.getLazyLoadJsUrl('subscription');
            if (url) {
                // 检查页面上是否已存在相同 URL 的 script 标签
                const existingScripts = Array.from(document.scripts);
                const scriptExists = existingScripts.some(script => {
                    const src = script.getAttribute('src');
                    return src && src.includes(url);
                });
                if (scriptExists) {
                    return;
                }
                const script = document.createElement('script');
                script.src = url;
                script.async = true;
                document.body.appendChild(script);
            }
        };
    },
    
    // 发送验证码
    sendCode: function (obj, callback) {
        return async (dispatch, getState) => {
            const stepToVerificationCode = () => {
                dispatch(this.changeStep('verificationCode'));

                dispatch(this.changeForgetPasswordTimeShow(true));
                FJUtil.countDown('forgetPassword', 60, value => {
                    // 改变倒计时剩余时间，如果value 》= 0， 则调用reducers中的方法继续--
                    if (Boolean(value)) {
                        dispatch(this.setForgetPasswordIntervalTime(value));
                    } else {
                        dispatch(this.changeForgetPasswordTimeShow(false));
                        dispatch(this.setForgetPasswordIntervalTime(null));
                        dispatch(this.setCountdownAndSendCode(true));
                    }
                })();
            };

            let result = await FJNetworkStore.checkAccountExist({ email: obj.email }).catch(() => {
                if (callback) {
                    callback({ result: false, errTip: FJLocalStore._('network-error') });
                }
            });
            // 201 是账号是登录状态，即账号已经注册过
            if (result.code === 201) {
                // 201之后人机验证，验证通过再后续进行
                this.recaptchaVerify(obj, ({ result }) => {
                    if (result) {
                        stepToVerificationCode();
                    }
                }, 'resetpwd')
            } else if (result.code === 200) {
                // 账号没有注册过
                if (callback) {
                    callback({ result: false, errTip: FJLocalStore._('email-is-not-registered') });
                }
            } else {
                if (callback) {
                    callback({ result: false, errTip: FJLocalStore._('request-failed-try-again') });
                }
            }
        };
    },

    // 重发验证码
    resendCode: function (obj, callback, errCallback) {
        return () => {
            this.recaptchaVerify(obj, ({ result }) => {
                callback(result)
            }, 'resendCode')
        };
    },

    /**
     * @description 验证输入的验证码是否正确
     * @param obj， {code, email, type}, type 类型 1:注册 2:忘记密码
     * @param callback
     * @returns {function(*, *): void}
     */
    confirmCode: function (obj, callback) {
        return (dispatch, getState) => {
            let email = getState().mainStore.confirmEmail;

            FJNetworkStore.confirmCode({
                email,
                ...obj,
            })
                .then(result => {
                    // 状态码，200请求成功 215参数失败 316验证码错误 317验证码过期
                    let code = result.code;
                    if (code === 200) {
                        dispatch(this.changeStep(`${obj.type === 1 ? 'setPassword' : 'resetPassword'}`));
                        dispatch(this.changeRegisterCode(obj.code));
                        callback({ result: true });
                    } else if (code === 316) {
                        callback({ result: false, errTip: FJLocalStore._('invalid-verification-code') });
                    } else if (code === 317) {
                        callback({ result: false, errTip: FJLocalStore._('expired-code') });
                    } else {
                        callback({ result: false, errTip: FJLocalStore._('request-failed-try-again') });
                    }
                })
                .catch(() => {
                    callback({ networkFail: true, errTip: FJLocalStore._('network-error') });
                });
        };
    },
    // 重置密码
    resetPassword: function (data, callback) {
        return (dispatch, getState) => {
            let email = getState().mainStore.confirmEmail;
            FJNetworkStore.resetPassword({
                email: email,
                newPassword: data.newPassword,
                confirmPassword: data.confirmPassword,
                code: data.code,
            })
                .then(result => {
                    let code = result.code;
                    // 状态码，200：请求成功 215参数错误 316验证码错误 317 验证码过期 500网络错误
                    // 305 密码长度不对 205 两次密码不匹配 201 新旧密码一样 这个状态前端已经做了判断进行规避
                    if (code === 200) {
                        window.needLoginRecaptcha = false;
                        dispatch(this.emailLogin({ email: email, password: data.confirmPassword }));
                    } else if (code === 317) {
                        // 验证码过期提示
                        dispatch(this.changeStep('default'));
                        dispatch(this.changeRegisterCode(''));
                        FJMessageStore.addMessage(FJLocalStore._('reset-flow-overtime'), 'error');
                    } else if (code === 500) {
                        callback({ result: false, errTip: FJLocalStore._('request-failed-try-again') });
                    } else if (code === 514) {
                        callback({ result: false, errTip: FJLocalStore._('enter-valid-email') });
                    } else {
                        callback({ result: false, errTip: FJLocalStore._('request-failed-try-again') });
                    }
                })
                .catch(() => {
                    callback({ networkFail: true, errTip: FJLocalStore._('network-error') });
                });
        };
    },
    sendGoogleTokenAction: function (accessToken) {
        return async (dispatch, getState) => {
            let method = getState().mainStore.method;
            let page = getState().mainStore.page;
            let origin = method === 'single' ? page : window.location.pathname;
            const getCountryCodeRes = await FJNetworkStore.getUserCountryCode();
            let loc = typeof getCountryCodeRes === 'string' ? getCountryCodeRes : '';
            FJNetworkStore.sendGoogleToken(accessToken, loc)
                .then(res => {
                    if (res.data.register === true) {
                        FJUtil.ealog('sign up', {
                            signUpMode: 'google',
                            loc: loc,
                            'page&panel': method === 'single' ? 'page' : 'panel',
                            signUpPage: 'page_' + origin,
                            signUpAccount: 'Account_' + res.data.email,
                        });
                        FJUtil.facebookAdTracking('CompleteRegistration');
                    }
                    if (method !== 'single') {
                        dispatch(this.closeLoginView());
                        if (FJUtil.isMobile()) {
                            dispatch(this.loadSubscriptionJs());
                        }
                        window.fjuser.dispatchCallbacks(window.fjuser.eventType.login, true, res);
                    } else {
                        // window.location.href = FJLocalStore.getJumpUrl('/editor/')
                        window.location.href = FJUtil.getBaseUrl();
                    }

                    if (res.code !== 200) {
                        FJUtil.ealog('sign up error', {
                            'error reason': res.message,
                            'error mode': 'Google',
                            'error page': 'page_' + origin,
                            'error account': 'Google',
                        });
                    }
                })
                .catch(e => {
                    FJUtil.ealog('sign up error', {
                        'error reason': 'connectGoogleUser catch',
                        'error mode': 'Google',
                        'error page': 'page_' + origin,
                        'error account': 'Google',
                    });
                });
        };
    },
    sendFacebookTokenAction: function (accessToken) {
        return async (dispatch, getState) => {
            let method = getState().mainStore.method;
            let page = getState().mainStore.page;
            let origin = method === 'single' ? page : window.location.pathname;
            const getCountryCodeRes = await FJNetworkStore.getUserCountryCode();
            let loc = typeof getCountryCodeRes === 'string' ? getCountryCodeRes : '';
            FJNetworkStore.sendFacebookToken(accessToken, loc)
                .then(res => {
                    if (res.data.register === true) {
                        FJUtil.ealog('sign up', {
                            signUpMode: 'facebook',
                            loc: loc,
                            'page&panel': method === 'single' ? 'page' : 'panel',
                            signUpPage: 'page_' + origin,
                            signUpAccount: 'Account_' + res.data.email,
                        });
                        FJUtil.facebookAdTracking('CompleteRegistration');
                    }
                    if (method !== 'single') {
                        dispatch(this.closeLoginView());
                        if (FJUtil.isMobile()) {
                            dispatch(this.loadSubscriptionJs());
                        }
                        window.fjuser.dispatchCallbacks(window.fjuser.eventType.login, true, res);
                    } else {
                        // window.location.href = FJLocalStore.getJumpUrl('/editor/')
                        window.location.href = FJUtil.getBaseUrl();
                    }

                    if (res.code === 303) {
                        FJUtil.ealog('sign up error', {
                            'error reason': 'facebook without email',
                            'error mode': 'Facebook',
                            'error page': 'page_' + origin,
                            'error account': 'Facebook',
                        });
                        return;
                    }

                    if (res.code !== 200) {
                        FJUtil.ealog('sign up error', {
                            'error reason': res.message || res.msg,
                            'error mode': 'Facebook',
                            'error page': 'page_' + origin,
                            'error account': 'Facebook',
                        });
                    }
                })
                .catch(e => {
                    FJUtil.ealog('sign up error', {
                        'error reason': 'connectFacebookUser catch',
                        'error mode': 'Facebook',
                        'error page': 'page_' + origin,
                        'error account': 'Facebook',
                    });
                });
        };
    },
    changeLoginPasswordStatusAction: function (status) {
        return {
            type: FJActionConstant.CHANGE_LOGIN_PASSWORD_STATUS,
            status: status,
        };
    },

    forceUpdate: function () {
        return {
            type: FJActionConstant.FORCE_UPDATE,
        };
    },

    setIsRestoreLoadingAction: function (bool) {
        return {
            type: FJActionConstant.SET_IS_RESTORE_LOADING,
            data: bool,
        };
    },

    setRestoreExpireTimeAction: function (time) {
        return {
            type: FJActionConstant.SET_RESTORE_EXPIRE_TIME,
            data: time,
        };
    },

    restoreAccountAction: function () {
        return async (dispatch, getState) => {
            dispatch(this.setIsRestoreLoadingAction(true));
            const email = getState().mainStore.email;
            const loginInfo = FJUtil.getLoginInfo();
            try {
                FJUtil.ealog('delete_restore_click')
                const { code, data } = await FJNetworkStore.restoreAccount(loginInfo.email || email);
                if (code === 200) {
                    if (loginInfo.email) {
                        // 三方登录
                        if (loginInfo.type === 'google') {
                            dispatch(this.sendGoogleTokenAction(loginInfo.id_token));
                        } else if (loginInfo.type === 'facebook') {
                            dispatch(this.sendFacebookTokenAction(loginInfo.id_token));
                        }
                        FJUtil.setLoginInfo({});
                    } else {
                        dispatch(this.changeStep('login'));
                        FJUtil.setLoginInfo({});
                    }
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-restore'), 'error');
                }
                dispatch(this.setIsRestoreLoadingAction(false));
            } catch (e) {
                dispatch(this.setIsRestoreLoadingAction(false));
                FJMessageStore.addMessage(FJLocalStore._('failed-to-restore'), 'error');
            }
        };
    },
};
